<template>
  <BaseTip>
    <div class="qrcode-tip" :id="id"></div>
  </BaseTip>
</template>

<script>
import BaseTip from './BaseTip.vue'
export default {
  components: {
    BaseTip
  },
  props: {
    lang: {
      type: Object,
      default () {
        return {
          title: 'qrcode'
        }
      }
    }
  },
  data () {
    return {
      id: 'tip-qrcode',
      /**
       * @see https://github.com/kazuhikoarase/qrcode-generator/tree/master/js
       */
      qr: null,
      typeNumber: 0, // 0 === auto detect
      errorCorrectionLevel: 'M',
      cellSize: 4,
      margin: 0
    }
  },
  computed: {
    url () {
      return location.href
    }
  },
  mounted () {
    this.qr = window.qrcode(this.typeNumber, this.errorCorrectionLevel)
    this.qr.addData(this.url)
    this.qr.make()
    document.getElementById(this.id).innerHTML = this.qr.createSvgTag(this.cellSize, this.margin)
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.qrcode-tip {
  background-color: var(--colorWhite);
  width: fit-content;
  padding: 12px 12px;
  border-radius: var(--borderRadius1);
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/tip/QrcodeTip.vue